/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { isValue } from './object';

class Bundle {
  static bundle: any = {};
  static setValue(pKey: string, pValor: any) {
    if (this.bundle === undefined) {
      this.bundle = {};
    }
    this.bundle[pKey] = pValor;
  }

  static getValue(pKey: string) {
    return this.bundle[pKey];
  }

  static cleanValues() {
    this.bundle = {};
  }
  static clearValue(pKey: string) {
    if (isValue(this.bundle[pKey])) {
      this.bundle[pKey] = null;
    }
  }
}

//const instance = new Bundle();
export default Bundle;
